import { createAsyncThunk } from '@reduxjs/toolkit';
import weddingService from '../../../api/services/wedding';

export const postClientContract = createAsyncThunk('wedding/post-client-contract', async requestData => {
  const { type, files, name, userId } = requestData;
  let formData = new FormData();

  formData.append('type', type);
  formData.append('name', name);
  formData.append('userId', userId);

  if (Array.isArray(files)) {
    files.forEach((image, index) => {
      formData.append(`files`, image);
    });
  }
  return await weddingService.postClientContract(formData);
});

export const getClientContracts = createAsyncThunk('wedding/get-client-contracts', async requestData => {
  return await weddingService.getClientContracts(requestData);
});

export const getDocumentById = createAsyncThunk('wedding/get-document-by-id', async id => {
  return await weddingService.getDocumentById(id);
});

export const deleteDocument = createAsyncThunk('wedding/delete-document', async ({ id }) => {
  return await weddingService.deleteDocument(id);
});

export const editDocument = createAsyncThunk('wedding/edit-document', async requestData => {
  return await weddingService.editDocument(requestData);
});

export const setClientWeddingDate = createAsyncThunk('wedding/setClientWeddingDate', async ({ id, body }) => {
  return await weddingService.setClientWeddingDate(id, body);
});

export const deleteLeadClient = createAsyncThunk('wedding/deleteLeadClient', async ({ id }) => {
  return await weddingService.deleteLeadClient(id);
});

export const acceptClientDeleteRequest = createAsyncThunk('wedding/acceptClientDeleteRequest', async ({ id, body }) => {
  return await weddingService.acceptClientDeleteRequest(id, body);
});

export const sendDeleteRequestToClient = createAsyncThunk('wedding/sendDeleteRequestToClient', async ({ id }) => {
  return await weddingService.sendDeleteRequestToClient(id);
});

export const rejectContractDeleteRequest = createAsyncThunk('wedding/rejectContractDeleteRequest', async body => {
  return await weddingService.rejectContractDeleteRequest(body);
});
